import React from 'react'

import { arrayOf, number, shape, string, bool } from 'prop-types'

import NewDesignerSection from 'Pods/LazyLoaded/NewDesignerSection/NewDesignerSection'

function FeaturedDesignersSection({ featuredDesigners, locale = 'en', showTitles = true }) {
  return (
    <div className="featured-designers-container">
      {featuredDesigners.length > 0 && (
        <>
          {showTitles && <h2 className="featured-designers-container__title cgt-mt-16">Premium Models For Free</h2>}
          <div className="featured-designers-container__list">
            {featuredDesigners.slice(0, 6).map((designer) => (
              <NewDesignerSection
                key={designer.id}
                userInfo={designer}
                locale={locale}
                showTitle={showTitles}
              />
            ))}
          </div>
        </>
      )}
    </div>
  )
}

FeaturedDesignersSection.propTypes = {
  featuredDesigners: arrayOf(
    shape({
      id: number.isRequired,
      user: shape({
        id: number.isRequired,
        username: string.isRequired,
        avatar: string,
        rating: number.isRequired,
        totalModels: number.isRequired,
      }).isRequired,
      keywords: arrayOf(string).isRequired,
      products: arrayOf(
        shape({
          id: number.isRequired,
          title: string.isRequired,
          primaryImage: string.isRequired,
          price: number.isRequired,
          finalPrice: number.isRequired,
          formats: arrayOf(string).isRequired,
          slug: string.isRequired,
          percentage: number,
        })
      ).isRequired,
    })
  ).isRequired,
  locale: string,
  showTitles: bool,
}

export default FeaturedDesignersSection
